import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EventType } from '@dossierhq/core';
import { DateDisplay, EmptyStateMessage, Table, toSizeClassName } from '@dossierhq/design';
import { ChangelogStateActions, } from '../../reducers/ChangelogReducer/ChangelogReducer.js';
export function ChangelogList({ changelogState, dispatchChangelogState }) {
    const { edges, query: { reverse }, } = changelogState;
    const direction = reverse ? 'desc' : 'asc';
    const isEmpty = edges?.length === 0;
    return (_jsxs(Table, { className: isEmpty ? toSizeClassName({ height: '100%' }) : undefined, hoverable: !isEmpty, children: [_jsx(Table.Head, { children: _jsxs(Table.Row, { sticky: true, children: [_jsx(Table.Header, { narrow: true, children: "Event" }), _jsx(Table.Header, { children: "Details" }), _jsx(Table.Header, { narrow: true, order: direction, onClick: () => handleHeaderClick(dispatchChangelogState, reverse), children: "Created at" })] }) }), _jsx(Table.Body, { children: isEmpty ? (_jsx(Table.Row, { children: _jsx(Table.Cell, { className: toSizeClassName({ height: '100%' }), colSpan: 3, children: _jsx(EmptyStateMessage, { icon: "search", title: "No events", message: "No actions have been performed" }) }) })) : (edges?.map((edge) => {
                    if (edge.node.isOk()) {
                        const event = edge.node.value;
                        return _jsx(ChangelogListRow, { event }, edge.cursor);
                    }
                })) })] }));
}
function ChangelogListRow({ event }) {
    let details;
    switch (event.type) {
        case EventType.createPrincipal:
            details = null;
            break;
        case EventType.updateSchema:
            details = `Version ${event.version}`;
            break;
        default: {
            details = (_jsxs(_Fragment, { children: [event.entities
                        .map((entity) => `${entity.name} (${entity.type}) version ${entity.version}`)
                        .join(', '), event.unauthorizedEntityCount > 0 ? (_jsxs("i", { children: [event.unauthorizedEntityCount, " other entities"] })) : null] }));
            break;
        }
    }
    return (_jsxs(Table.Row, { children: [_jsx(Table.Cell, { children: event.type }), _jsx(Table.Cell, { children: details }), _jsx(Table.Cell, { children: _jsx(DateDisplay, { date: event.createdAt }) })] }));
}
function handleHeaderClick(dispatchSearchEntityState, reverse) {
    const newReverse = !reverse;
    dispatchSearchEntityState(new ChangelogStateActions.SetQuery({ reverse: newReverse }, { partial: true, resetPagingIfModifying: true }));
}
//# sourceMappingURL=ChangelogList.js.map